import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Box, Stack, styled } from "@schaeffler-commerce/design-system";
import { Link } from "~/common/components/Link";
import type { FooterNavigationNode } from "./PageFooter";
import { sendGAEvent } from "~/app/analytics/ga/ga";
import { useTranslation } from "react-i18next";
import { Facebook as FacebookIcon } from "@schaeffler-commerce/design-system";
import { LinkedIn as LinkedInIcon } from "@schaeffler-commerce/design-system";
import type { JSX } from "react";
const SocialContainer = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "center",
  gap: theme.spacing(3),
}));

interface Props {
  social: FooterNavigationNode[];
  className?: string;
}
const SocialLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  "&:hover": {
    color: theme.palette.text.primary,
  },
}));

const socialIcons: Record<string, JSX.Element> = {
  TWITTER: <XIcon fontSize="medium" />,
  LINKEDIN: <LinkedInIcon fontSize="medium" />,
  FACEBOOK: <FacebookIcon fontSize="medium" />,
  INSTAGRAM: <InstagramIcon fontSize="medium" />,
  YOUTUBE: <YouTubeIcon fontSize="medium" />,
};

const FooterTopLinksColumn = styled("ul")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  listStyle: "none",
  margin: theme.spacing(0),
  padding: theme.spacing(0),
  gap: theme.spacing(3),
  "& > li": {
    display: "flex",
    alignItems: "center",
  },
}));

export const SocialLinks = ({ social }: Props) => {
  const { t } = useTranslation();
  if (!social?.length) {
    return null;
  }

  return (
    <SocialContainer>
      <Box>
        <FooterTopLinksColumn>
          {social?.map((link) => {
            const key = link.title.toUpperCase();

            return (
              <li key={link.title}>
                <SocialLink
                  appearance="secondary"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t(link.title)}
                  data-ga-name={link.gaLabel}
                  id={link.gaLabel}
                  onClick={(event) => {
                    sendGAEvent({
                      eventCategory: "Navigation",
                      eventAction: "Footer",
                      eventLabel: event.currentTarget.dataset.gaName,
                    });
                  }}
                >
                  {socialIcons[key]}
                </SocialLink>
              </li>
            );
          })}
        </FooterTopLinksColumn>
      </Box>
    </SocialContainer>
  );
};
